// THE switch of the Service package: one place, used by the UI, the API and the AI tools. company = { packages: { service: true } }.
// No company, no row, no table (before sql/service-package.sql): off. Off means the service code paths are not used at all.
export function hasPackage(company, pkg) {
  return !!(company && company.packages && company.packages[pkg] === true)
}
// rows of public.company_packages -> the shape hasPackage reads
export function packagesOf(rows) {
  const out = {}
  for (const r of rows || []) if (r && r.enabled === true && r.package) out[r.package] = true
  return out
}
